import { Component, OnInit } from '@angular/core';
import { SessionService } from './store/session/session.service';
import { filter } from 'rxjs/operators';

@Component({
	selector: 'app-root',
	template: '<router-outlet></router-outlet>'
})
export class AppComponent implements OnInit {
	constructor(private sessionService: SessionService) {}

	ngOnInit(): void {
		this.sessionService
			.isAuthenticated()
			.pipe(filter(isAuthenticated => isAuthenticated))
			.subscribe(() => {
				this.sessionService.getUser().subscribe();
			});
	}
}
